import React from 'react'

type Props = {
    onClick: () => void;
    label: string;
    selected: boolean;
}

const TabButton = (props: Props) => {
    function getClassName() {
        if (props.selected) {
            return "border-utility-mutedLight border-b-solid border-b-[4px]"
        }
        return "hover:border-utility-mutedLight hover:border-b-solid hover:border-b-[4px] hover:border-opacity-40"
    }

    return (
        <button
            onClick={props.onClick}
            className={`text-center pb-1 px-6 text-utility-mutedLight border-transparent transition-all duration-150 border-b-solid border-b-[4px] font-semibold py-2 hover:bg-utility-mutedLight hover:bg-opacity-10 ${getClassName()}`}>
            {props.label}
        </button>
    )
}

export default TabButton